/**
 * SI Routes Component
 *
 * Rotas do Portal do SI (src/features/SiPortal): `/si` redireciona pra aba Início (quem é do SI
 * volta na última aba em que estava — SiPortalIndexRedirect); cada aba
 * é uma rota (a aba ativa vem da URL, como no Portal do DP). Os deep-links antigos continuam
 * valendo: `/si/nova`, `/si/solicitacoes/:id` e `/si/equipamentos` (→ aba Ativos). Post aberto em
 * `/si/inicio/publicacao/:id` (a aba Início continua marcada).
 */

import { Routes, Route, Navigate } from 'react-router-dom';
import {
  SolicitacoesListPage,
  NovaSolicitacaoPage,
  SolicitacaoDetailsPage,
  EquipamentosListPage,
} from '@/features/SI/pages';
import {
  SiInicioPage,
  SiPortalLayout,
  SiPortalTabGuard,
  SiPortalIndexRedirect,
  SiSolicitacoesPage,
  PublicacaoPage,
  PublicacoesGestaoPage,
  CienciaRelatorioPage,
  DocumentosPage,
  GuardioesPage,
} from '@/features/SiPortal';

export default function SIRoutes() {
  return (
    <Routes>
      <Route element={<SiPortalLayout />}>
        <Route index element={<SiPortalIndexRedirect />} />
        <Route path="inicio" element={<SiInicioPage />} />
        <Route path="inicio/publicacao/:id" element={<PublicacaoPage />} />
        <Route path="solicitacoes" element={<SiSolicitacoesPage />} />
        <Route path="documentos" element={<DocumentosPage />} />
        <Route path="documentos/:id" element={<DocumentosPage />} />
        <Route
          path="guardioes"
          element={
            <SiPortalTabGuard tabId="guardioes">
              <GuardioesPage />
            </SiPortalTabGuard>
          }
        />
        <Route
          path="controle"
          element={
            <SiPortalTabGuard tabId="controle">
              <SolicitacoesListPage aba="fila" />
            </SiPortalTabGuard>
          }
        />
        <Route
          path="dashboard"
          element={
            <SiPortalTabGuard tabId="dashboard">
              <SolicitacoesListPage aba="dashboard" />
            </SiPortalTabGuard>
          }
        />
        <Route
          path="ativos"
          element={
            <SiPortalTabGuard tabId="ativos">
              <EquipamentosListPage embutida />
            </SiPortalTabGuard>
          }
        />
        <Route
          path="publicacoes"
          element={
            <SiPortalTabGuard tabId="publicacoes">
              <PublicacoesGestaoPage />
            </SiPortalTabGuard>
          }
        />
        <Route
          path="publicacoes/:id/ciencia"
          element={
            <SiPortalTabGuard tabId="publicacoes">
              <CienciaRelatorioPage />
            </SiPortalTabGuard>
          }
        />
      </Route>
      <Route path="nova" element={<NovaSolicitacaoPage />} />
      <Route path="solicitacoes/:id" element={<SolicitacaoDetailsPage />} />
      <Route path="equipamentos" element={<Navigate to="/si/ativos" replace />} />
    </Routes>
  );
}
